import { Component, Input } from '@angular/core';
import { AngularModule } from '../../../../modules/angular.module';

@Component({
	selector: 'app-form-title',
	standalone: true,
	imports: [AngularModule],
	templateUrl: './form-title.component.html',
	styleUrl: './form-title.component.scss',
})
export class FormTitleComponent {
	@Input('editMode') public editMode: boolean = false;
	@Input('model') public model: string = '';
}
